Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='src/PlaceholderChild.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();

var _react=require('react');var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

















PlaceholderChild=function(_React$PureComponent){_inherits(PlaceholderChild,_React$PureComponent);



function PlaceholderChild(props){_classCallCheck(this,PlaceholderChild);var _this=_possibleConstructorReturn(this,(PlaceholderChild.__proto__||Object.getPrototypeOf(PlaceholderChild)).call(this,
props));

_this.state={
rejectionHandlers:_this.getRejectionHandlers(props),
resolveHandlers:_this.getResolveHandlers(props)};return _this;

}_createClass(PlaceholderChild,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(

newProps){
if(this.props.rejecters!==newProps.rejecters){
this.setState({
rejectionHandlers:this.getRejectionHandlers(newProps)});

}
if(this.props.resolvers!==newProps.resolvers){
this.setState({
resolveHandlers:this.getResolveHandlers(newProps)});

}
}},{key:'getResolveHandlers',value:function getResolveHandlers(

props){var _this2=this;
var resolveHandlers=props.resolvers.reduce(function(o,key){return _extends({},
o,_defineProperty({},
key,_this2.handleResolve.bind(_this2,key)));},

{});
return resolveHandlers;
}},{key:'getRejectionHandlers',value:function getRejectionHandlers(

props){var _this3=this;
var rejectionHandlers=props.rejecters.reduce(function(o,key){return _extends({},
o,_defineProperty({},
key,_this3.handleReject.bind(_this3,key)));},

{});
return rejectionHandlers;
}},{key:'handleResolve',value:function handleResolve(

parentPropName,value){var _props$props;var _props=
this.props,id=_props.id,_resolve=_props._resolve;
_resolve(id,value);for(var _len=arguments.length,rest=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){rest[_key-2]=arguments[_key];}
this.props.props[parentPropName]&&(_props$props=this.props.props)[parentPropName].apply(_props$props,[value].concat(rest));
}},{key:'handleReject',value:function handleReject(

parentPropName,reason){var _props$props2;var _props2=
this.props,id=_props2.id,_reject=_props2._reject;
_reject(id,reason);for(var _len2=arguments.length,rest=Array(_len2>2?_len2-2:0),_key2=2;_key2<_len2;_key2++){rest[_key2-2]=arguments[_key2];}
this.props.props[parentPropName]&&(_props$props2=this.props.props)[parentPropName].apply(_props$props2,[reason].concat(rest));
}},{key:'render',value:function render()

{var _props3=
this.props,Component=_props3.component,props=_props3.props;
return _react2.default.createElement(Component,_extends({},
props,
this.state.rejectionHandlers,
this.state.resolveHandlers,{
onCancel:this.props.onCancel,__source:{fileName:_jsxFileName,lineNumber:79}}));

}}]);return PlaceholderChild;}(_react2.default.PureComponent);exports.default=PlaceholderChild;
//# sourceMappingURL=PlaceholderChild.js.map